/* Announcement Bar New - Swiper Initialization */
(function () {
  'use strict';

  var measureCtx = null;

  function getMeasureContext() {
    if (measureCtx) return measureCtx;
    var canvas = document.createElement('canvas');
    measureCtx = canvas.getContext('2d');
    return measureCtx;
  }

  function measureTextWidth(text, styles) {
    var ctx = getMeasureContext();
    if (!ctx) return 0;
    var fontSize = styles.fontSize || '12px';
    var fontFamily = styles.fontFamily || 'sans-serif';
    var fontWeight = styles.fontWeight || '400';
    var fontStyle = styles.fontStyle || 'normal';
    ctx.font = fontStyle + ' ' + fontWeight + ' ' + fontSize + ' ' + fontFamily;
    return ctx.measureText(text || '').width;
  }

  function scheduleIdle(fn, timeout) {
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(fn, { timeout: timeout || 1500 });
    } else {
      setTimeout(fn, 1);
    }
  }

  function initAnnouncementSwiper() {
    var announcementSwipers = document.querySelectorAll('.announcement-swiper.swiper-container');

    announcementSwipers.forEach(function (swiperEl) {
      if (swiperEl.swiper) return;

      var nextBtn = swiperEl.querySelector('.swiper-button-next');
      var prevBtn = swiperEl.querySelector('.swiper-button-prev');

      if (typeof Swiper === 'undefined' || !nextBtn || !prevBtn) return;

      var swiper = new Swiper(swiperEl, {
        loop: true,
        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn
        },
        speed: 600,
        slidesPerView: 1,
        spaceBetween: 0
      });

      var autoplayInterval = null;
      var isPaused = false;

      function startAutoplay() {
        if (autoplayInterval) clearInterval(autoplayInterval);
        autoplayInterval = setInterval(function () {
          if (!isPaused && swiper && !swiper.destroyed) {
            swiper.slideNext();
          }
        }, 5000);
      }

      function stopAutoplay() {
        if (autoplayInterval) {
          clearInterval(autoplayInterval);
          autoplayInterval = null;
        }
      }

      swiperEl.addEventListener('mouseenter', function () {
        isPaused = true;
      });
      swiperEl.addEventListener('mouseleave', function () {
        isPaused = false;
      });

      setTimeout(startAutoplay, 500);

      nextBtn.addEventListener('click', function () {
        stopAutoplay();
        setTimeout(startAutoplay, 5000);
      });
      prevBtn.addEventListener('click', function () {
        stopAutoplay();
        setTimeout(startAutoplay, 5000);
      });
    });
  }

  function tryInit() {
    if (typeof Swiper !== 'undefined') {
      initAnnouncementSwiper();
      return true;
    }
    return false;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      if (!tryInit()) {
        document.addEventListener('swiper-loaded', initAnnouncementSwiper);
        setTimeout(function () {
          if (!tryInit()) setTimeout(tryInit, 1000);
        }, 500);
      }
    });
  } else if (!tryInit()) {
    document.addEventListener('swiper-loaded', initAnnouncementSwiper);
    setTimeout(tryInit, 500);
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.localization-trigger')) return;
    var drawerTrigger = document.querySelector('[data-localization-trigger]');
    if (drawerTrigger) drawerTrigger.click();
  });

  function initReadMore() {
    var announcementBar = document.querySelector('.top-bar_topBar__Jri68');
    if (!announcementBar) return;

    var expandedSlide = null;
    var isExpanding = false;
    var isRestoringExpanded = false;
    var checkedOnce = false;

    var observer = new MutationObserver(function (mutations) {
      if (isRestoringExpanded) return;
      for (var i = 0; i < mutations.length; i++) {
        var mutation = mutations[i];
        if (mutation.type !== 'attributes' || mutation.attributeName !== 'class') continue;
        if (mutation.target !== announcementBar) continue;
        if (expandedSlide === null || announcementBar.dataset.isExpanded !== 'true') continue;
        if (announcementBar.classList.contains('expanded')) continue;

        isRestoringExpanded = true;
        announcementBar.classList.add('expanded');
        if (announcementBar.dataset.expandedHeight) {
          announcementBar.style.setProperty('height', announcementBar.dataset.expandedHeight, 'important');
        }
        setTimeout(function () {
          isRestoringExpanded = false;
        }, 50);
      }
    });

    observer.observe(announcementBar, {
      attributes: true,
      attributeFilter: ['class']
    });

    function collapseSlide(slide) {
      if (!slide) return;
      var textWrapper = slide.querySelector('.announcement-text-wrapper');
      var readMoreBtn = slide.querySelector('.announcement-read-more');
      var readMoreText = slide.querySelector('.read-more-text');
      var readLessText = slide.querySelector('.read-less-text');
      if (!textWrapper || !readMoreBtn || !readMoreText || !readLessText) return;

      var linesNeeded = parseInt(slide.dataset.linesNeeded, 10) || 0;
      if (linesNeeded > 1) {
        textWrapper.classList.add('clamped');
        textWrapper.style.webkitLineClamp = '1';
        textWrapper.style.display = '-webkit-box';
        textWrapper.style.webkitBoxOrient = 'vertical';
        textWrapper.style.overflow = 'hidden';
        readMoreText.style.display = 'inline';
        readLessText.style.display = 'none';
        readMoreBtn.style.position = 'static';
        readMoreBtn.style.top = 'auto';
        readMoreBtn.style.left = 'auto';
        readMoreBtn.style.right = 'auto';
        readMoreBtn.style.transform = 'none';
        readMoreBtn.style.display = 'inline';
        readMoreBtn.style.marginLeft = '4px';
      } else {
        readMoreBtn.style.display = 'none';
      }
    }

    function showReadLessOnAllSlides() {
      document.querySelectorAll('.swiper-slide.top-bar-center_swiperSlide__m3glF').forEach(function (slide) {
        var readMoreBtn = slide.querySelector('.announcement-read-more');
        var readMoreText = slide.querySelector('.read-more-text');
        var readLessText = slide.querySelector('.read-less-text');
        if (!readMoreBtn || !readMoreText || !readLessText) return;
        readMoreText.style.display = 'none';
        readLessText.style.display = 'inline';
        readMoreBtn.style.display = 'inline';
      });
    }

    function hideReadLessOnAllSlides() {
      document.querySelectorAll('.swiper-slide.top-bar-center_swiperSlide__m3glF').forEach(function (slide) {
        var readMoreBtn = slide.querySelector('.announcement-read-more');
        var readMoreText = slide.querySelector('.read-more-text');
        var readLessText = slide.querySelector('.read-less-text');
        if (!readMoreBtn || !readMoreText || !readLessText) return;
        var linesNeeded = parseInt(slide.dataset.linesNeeded, 10) || 0;
        if (linesNeeded > 1) {
          readMoreText.style.display = 'inline';
          readLessText.style.display = 'none';
          readMoreBtn.style.display = 'inline';
        } else {
          readMoreBtn.style.display = 'none';
        }
      });
    }

    function expandSlide(slide) {
      if (!slide) return;
      var textWrapper = slide.querySelector('.announcement-text-wrapper');
      var readMoreBtn = slide.querySelector('.announcement-read-more');
      var readMoreText = slide.querySelector('.read-more-text');
      var readLessText = slide.querySelector('.read-less-text');
      if (!textWrapper || !readMoreBtn || !readMoreText || !readLessText) return;

      textWrapper.classList.remove('clamped');
      textWrapper.style.webkitLineClamp = 'unset';
      textWrapper.style.webkitBoxOrient = 'unset';
      textWrapper.style.display = 'inline-block';
      textWrapper.style.overflow = 'visible';
      readMoreText.style.display = 'none';
      readLessText.style.display = 'inline';
      readMoreBtn.style.position = 'static';
      readMoreBtn.style.top = 'auto';
      readMoreBtn.style.left = 'auto';
      readMoreBtn.style.right = 'auto';
      readMoreBtn.style.transform = 'none';
      readMoreBtn.style.display = 'inline';
    }

    announcementBar.addEventListener('click', function (e) {
      if (window.innerWidth < 900) return;

      var readMoreBtn = e.target.closest('.announcement-read-more');
      if (!readMoreBtn) return;

      e.preventDefault();
      e.stopPropagation();

      var currentSlide = readMoreBtn.closest('.swiper-slide');
      if (!currentSlide) return;

      if (announcementBar.classList.contains('expanded')) {
        document.querySelectorAll('.swiper-slide.top-bar-center_swiperSlide__m3glF').forEach(collapseSlide);
        announcementBar.classList.remove('expanded');
        announcementBar.style.setProperty('height', '', 'important');
        delete announcementBar.dataset.expandedHeight;
        delete announcementBar.dataset.isExpanded;
        expandedSlide = null;
        hideReadLessOnAllSlides();
        return;
      }

      isExpanding = true;
      expandedSlide = currentSlide;
      announcementBar.classList.add('expanded');
      announcementBar.dataset.isExpanded = 'true';
      expandSlide(currentSlide);
      showReadLessOnAllSlides();

      // One layout read after content expands, then animate — no forced void reflows
      requestAnimationFrame(function () {
        var startHeight = announcementBar.getBoundingClientRect().height;
        var container = currentSlide.querySelector('.top-bar-center_containerSlide__0_w97');
        var newHeight = 36;
        if (container) {
          newHeight = Math.max(container.scrollHeight + 8, 36);
        } else {
          newHeight = Math.max(announcementBar.scrollHeight + 8, 36);
        }

        announcementBar.style.height = startHeight + 'px';
        announcementBar.dataset.expandedHeight = newHeight + 'px';

        requestAnimationFrame(function () {
          announcementBar.style.setProperty('height', newHeight + 'px', 'important');
          if (!announcementBar.classList.contains('expanded')) {
            announcementBar.classList.add('expanded');
          }
          setTimeout(function () {
            isExpanding = false;
          }, 350);
        });
      });
    });

    function checkTextOverflow() {
      if (window.innerWidth < 900) {
        document.querySelectorAll('.swiper-slide.top-bar-center_swiperSlide__m3glF').forEach(function (slide) {
          var textWrapper = slide.querySelector('.announcement-text-wrapper');
          var readMoreBtn = slide.querySelector('.announcement-read-more');
          if (textWrapper) {
            textWrapper.classList.remove('clamped');
            textWrapper.style.webkitLineClamp = '';
            textWrapper.style.display = '';
            textWrapper.style.overflow = '';
            textWrapper.style.webkitBoxOrient = '';
            textWrapper.classList.add('js-processed');
          }
          if (readMoreBtn) {
            readMoreBtn.style.setProperty('display', 'none', 'important');
            readMoreBtn.style.setProperty('visibility', 'hidden', 'important');
            readMoreBtn.classList.remove('show');
          }
        });
        return;
      }

      if (
        announcementBar.classList.contains('expanded') ||
        isExpanding ||
        announcementBar.dataset.isExpanded === 'true'
      ) {
        return;
      }

      var slides = document.querySelectorAll('.swiper-slide.top-bar-center_swiperSlide__m3glF');
      var updates = [];

      // Phase 1: read layout + measure text via canvas (no DOM appends)
      slides.forEach(function (slide) {
        var textWrapper = slide.querySelector('.announcement-text-wrapper');
        var readMoreBtn = slide.querySelector('.announcement-read-more');
        if (!textWrapper || !readMoreBtn) return;

        var innerElement = textWrapper.querySelector('.top-bar-center_link__B7Li5');
        if (!innerElement) return;

        var computedStyle = window.getComputedStyle(textWrapper);
        var wrapperWidth = textWrapper.clientWidth || (textWrapper.parentElement && textWrapper.parentElement.clientWidth) || 0;
        if (wrapperWidth <= 0) return;

        var textWidth = measureTextWidth(innerElement.textContent || '', {
          fontSize: computedStyle.fontSize,
          fontFamily: computedStyle.fontFamily,
          fontWeight: computedStyle.fontWeight,
          fontStyle: computedStyle.fontStyle
        });

        // Letter-spacing is not included in canvas measureText; approximate from computed style
        var letterSpacing = parseFloat(computedStyle.letterSpacing);
        if (!isNaN(letterSpacing) && letterSpacing !== 0) {
          var chars = (innerElement.textContent || '').length;
          if (chars > 1) textWidth += letterSpacing * (chars - 1);
        }

        var linesNeeded = Math.ceil(textWidth / wrapperWidth);
        updates.push({
          slide: slide,
          textWrapper: textWrapper,
          readMoreBtn: readMoreBtn,
          readMoreText: readMoreBtn.querySelector('.read-more-text'),
          readLessText: readMoreBtn.querySelector('.read-less-text'),
          linesNeeded: linesNeeded
        });
      });

      // Phase 2: write styles in one pass
      updates.forEach(function (item) {
        item.slide.dataset.linesNeeded = String(item.linesNeeded);
        var textWrapper = item.textWrapper;
        var readMoreBtn = item.readMoreBtn;
        var readMoreText = item.readMoreText;
        var readLessText = item.readLessText;

        if (item.linesNeeded > 1) {
          readMoreBtn.classList.add('show');
          textWrapper.classList.add('clamped');
          textWrapper.style.webkitLineClamp = '1';
          textWrapper.style.display = '-webkit-box';
          textWrapper.style.webkitBoxOrient = 'vertical';
          textWrapper.style.overflow = 'hidden';
          if (readMoreText) readMoreText.style.display = 'inline';
          if (readLessText) readLessText.style.display = 'none';
          readMoreBtn.style.position = 'static';
          readMoreBtn.style.display = 'inline';
          readMoreBtn.style.marginLeft = '4px';
        } else {
          readMoreBtn.classList.remove('show');
          readMoreBtn.style.display = 'none';
          textWrapper.classList.remove('clamped');
          textWrapper.style.webkitLineClamp = '';
          textWrapper.style.display = '';
          textWrapper.style.overflow = '';
          textWrapper.style.webkitBoxOrient = '';
          textWrapper.style.removeProperty('webkit-line-clamp');
          textWrapper.style.removeProperty('webkit-box-orient');
        }

        textWrapper.classList.add('js-processed');
      });

      checkedOnce = true;
    }

    function runCheck() {
      scheduleIdle(function () {
        checkTextOverflow();
      }, 1200);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', runCheck);
    } else {
      runCheck();
    }

    document.addEventListener('click', function (e) {
      if (!e.target.closest('.announcement-nav-btn')) return;
      scheduleIdle(checkTextOverflow, 800);
    });

    document.querySelectorAll('.announcement-swiper.swiper-container').forEach(function (swiperEl) {
      if (!swiperEl.swiper) return;
      swiperEl.swiper.on('slideChange', function () {
        if (!checkedOnce) scheduleIdle(checkTextOverflow, 800);
      });
    });

    document.addEventListener('swiper-loaded', function () {
      scheduleIdle(checkTextOverflow, 1000);
    });

    var resizeTimeout;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function () {
        scheduleIdle(checkTextOverflow, 500);
      }, 200);
    });
  }

  // Defer read-more work until the browser is idle so it doesn't compete with LCP/TBT
  function bootReadMore() {
    scheduleIdle(initReadMore, 2000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootReadMore);
  } else {
    bootReadMore();
  }
})();
